<template>
  <div class="row">
    <m-content-wrapper :slicer="slicer" :content-type="contentType" :content-category="contentCategory">
      <template v-slot="{contents}">
        <div :class="itemClass" v-for="(content,index) in contents" :key="content.id">
          <m-a v-if="cardLink" class="text-decoration-none" :href="findLinkOnContent(content.abstraction)">
            <component :is="contentCard" :content="content"/>
          </m-a>
          <component v-else :is="contentCard" :content="content"/>
        </div>
      </template>
    </m-content-wrapper>
  </div>

</template>

<script>
import {ContentArchiveProps} from "../../Content/Archive/ContentArchiveProps";
import mContentWrapper from "../../Wrappers/ContentWrapper";
import mA from '../../Tags/A'
import {Cards} from "../Card/Cards";

export default {
  name: "ContentArchive3",
  components: {mA, mContentWrapper, ...Cards},
  props: {
    ...ContentArchiveProps,
  },
  methods: {
    contentLink(content) {
      const routerName = content.content_type === 0 ? 'SinglePage' : 'SinglePost';
      return {name: routerName, params: {slug: content.slug}}
    }
  }
}
</script>

<style scoped>

</style>